import { createSlice } from '@reduxjs/toolkit';
import { FETCH_STATUS } from '../../types/enums/fetch-status.enum';
import { PaginationType } from '../../types/utils/pagination.type';
import { ServiceTicketType } from '../../types/service-calls/service-calls.type';
import { getServiceCallReport } from './serviceCallReport.action';
import snackbarUtils from '../../utils/SnackbarUtils';

export interface ServiceCallReportState {
  list: PaginationType<ServiceTicketType> | null;
  fetchStatus: FETCH_STATUS;
}

const INITIAL_STATE: ServiceCallReportState = {
  list: null,
  fetchStatus: FETCH_STATUS.NULL,
};

export const serviceCallReportSlice = createSlice({
  name: 'serviceCallReport',
  initialState: INITIAL_STATE,
  reducers: {
    resetServiceCallReport: () => INITIAL_STATE,
  },
  extraReducers: builder => {
    builder
      .addCase(getServiceCallReport.pending, state => {
        state.fetchStatus = FETCH_STATUS.PENDING;
      })
      .addCase(getServiceCallReport.fulfilled, (state, action) => {
        state.fetchStatus = FETCH_STATUS.FULFILLED;
        state.list = action.payload ?? null;
      })
      .addCase(getServiceCallReport.rejected, (state, action) => {
        state.fetchStatus = FETCH_STATUS.REJECTED;
        state.list = null;
        snackbarUtils.error((action.payload as string) || 'Failed to load Service Call report.');
      });
  },
});

export const { resetServiceCallReport } = serviceCallReportSlice.actions;
export default serviceCallReportSlice.reducer;
